import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ButtonTemplate from '../ButtonTemplate';
import style from './styles/style.module.css';

export default class PrimaryButton extends PureComponent {
    render() {
        var props = { ...this.props };
        props.className = `${ this.props.className } ${ style.primaryButton }`.trim();
        props.labelClass = `${ this.props.labelClass } ${ style.label }`.trim();
        props.effectClass = style.effect;
        props.backgroundClass = style.backgroundColor;
        return (
            <ButtonTemplate { ...props } />
        );
    }
}
PrimaryButton.propTypes = {
    label: PropTypes.oneOfType( [
        PropTypes.string,
        PropTypes.object,
    ] ),
    className: PropTypes.string,
    onClick: PropTypes.func,
};
PrimaryButton.defaultProps = {
    label: '',
    className: '',
    labelClass: '',
    onClick: () => {},
};
